var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop_index_adv width_center_1200"},[_c('el-image',{attrs:{"width":"1200px","src":_vm.adv.adv_image,"alt":"","lazy":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }